import { Checkbox } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { IDistributionContact } from '../../../models';
import { WarningModal } from '../../common';

const CheckboxContainer = styled.div`
	text-align: left;
	margin-top: 50px;
`;
CheckboxContainer.displayName = 'CheckboxContainer';

export interface ISurveyParticipantActionWarningModalProps {
	audienceId: number;
	contentBody: string;
	headline: string;
	isOpen: boolean;
	isLoading: boolean;
	isResend?: boolean;
	resendLabel: string;
	selectedDistributionContacts: IDistributionContact[];
	surveyId: number;
	onSubmit: (surveyId: number, audienceId: number, distributionContactIds: number[], resend: boolean) => any;
	toggleWarningModal: (isOpen: boolean) => any;
	toggleResendCheckbox: (checked: boolean) => any;
}

export class SurveyParticipantActionWarningModal extends React.Component<ISurveyParticipantActionWarningModalProps, {}> {
	constructor(props: ISurveyParticipantActionWarningModalProps) {
		super(props);
	}

	public render() {
		const { headline, isOpen, isLoading, toggleWarningModal } = this.props;

		return (
			<WarningModal
				isOpen={isOpen}
				contentHeadline={headline}
				contentBody={this.getContent()}
				secondaryButtonText={ContentConstants.BUTTONS_CANCEL}
				onClose={() => toggleWarningModal(false)}
				onSubmit={this.handleOnSubmit}
				primaryButtonDisabled={isLoading}
			/>
		);
	}

	public getContent = () => {
		const { contentBody, isResend, resendLabel, selectedDistributionContacts } = this.props;

		return (
			<>
				{contentBody.replace('{total}', selectedDistributionContacts.length.toString())}

				<CheckboxContainer>
					<Checkbox checked={isResend} label={resendLabel} onChange={this.toggleResendCheckbox} />
				</CheckboxContainer>
			</>
		);
	};

	public toggleResendCheckbox = () => {
		const { isResend, toggleResendCheckbox } = this.props;
		toggleResendCheckbox(!isResend!);
	};

	public handleOnSubmit = () => {
		const { audienceId, isResend, selectedDistributionContacts, surveyId, onSubmit } = this.props;

		const distributionContactIds = selectedDistributionContacts.map((contact) => contact.distributionContactId);
		onSubmit(surveyId, audienceId, distributionContactIds, isResend!);
	};
}
